import moment from "moment";
import { useMemo } from "react";
import { parseTimestamp } from "src/helpers/message";
import { type DecryptedMessage } from "src/types/Message";
import { CallFormats } from "src/types/call";
interface Props {
  message: DecryptedMessage;
}
function CallEventMessage({
  message
}: Props): JSX.Element {
  const {
    content,
    timestamp,
    additional
  } = message;
  const formattedTimestamp: string = moment.unix(parseTimestamp(timestamp)).format('HH:mm');
  const renderIcon = useMemo(() => {
    const {
      type
    } = additional;
    if (type === undefined) return null;
    if ([CallFormats.CONFERENCE_VIDEO, CallFormats.VIDEO].includes(type)) return <svg className="w-4 mr-2" viewBox="0 0 22 16" fill="none">
                <path d="M15.3 5.97984L18.593 3.28484C19.409 2.61684 20.633 3.19884 20.632 4.25184L20.62 11.6008C20.619 12.6538 19.394 13.2308 18.58 12.5628L15.3 9.86784" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path fillRule="evenodd" clipRule="evenodd" d="M15.2969 11.5383C15.3778 13.3704 13.8992 14.9196 11.9946 14.9975C11.8543 15.0034 5.01531 14.9896 5.01531 14.9896C3.11996 15.1335 1.46115 13.7715 1.31165 11.9463C1.30039 11.8103 1.30346 4.47219 1.30346 4.47219C1.21949 2.63815 2.69604 1.08499 4.60163 1.00418C4.74396 0.997278 11.5738 1.01009 11.5738 1.01009C13.4783 0.868176 15.1423 2.24001 15.2897 4.07405C15.3 4.2061 15.2969 11.5383 15.2969 11.5383Z" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>;else if ([CallFormats.CONFERENCE_VOICE, CallFormats.VOICE].includes(type)) return <svg className="w-4 mr-2" viewBox="0 0 22 22" fill="none">
                <path d="M13.353 1.5C17.054 1.911 19.978 4.831 20.393 8.532" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.353 5.04297C15.124 5.38697 16.508 6.77197 16.853 8.54297" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path fillRule="evenodd" clipRule="evenodd" d="M10.0315 11.4724C14.0205 15.4604 14.9254 10.8467 17.4653 13.3848C19.9138 15.8328 21.3222 16.3232 18.2188 19.4247C17.8302 19.737 15.3613 23.4943 6.68447 14.8197C-1.99341 6.144 1.76157 3.67244 2.07394 3.28395C5.18377 0.173846 5.66682 1.58938 8.11539 4.03733C10.6541 6.5765 6.04254 7.48441 10.0315 11.4724Z" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>;else return null;
  }, [additional]);
  const renderDuration = useMemo(() => {
    const {
      duration
    } = additional;
    if (duration === undefined || Number.isNaN(duration)) return '';
    const format = duration / 1000 >= 3600 ? 'HH:mm:ss' : 'mm:ss';
    const formattedDuration = moment.utc(duration).format(format);
    return <span className="text-2xs ml-1">({formattedDuration})</span>;
  }, [additional]);
  return <div className='mx-auto bg-[#7B7BAC] flex items-center my-2 w-fit rounded-xl text-xs px-4' onClick={() => {
    console.log(message);
  }}>
            <div className='inline-flex items-center text-white py-2 pr-3'>
                {renderIcon}
                {content}{renderDuration}
            </div>
            <span className="text-2xs py-2 pl-3 text-[#E8E8EF] border-l border-[#BABAD9]">{formattedTimestamp}</span>
        </div>;
}
export default CallEventMessage;